module.exports = __webpack_public_path__ + "static/img/Wechat.6fc00411.png";